import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'normalize.css';
import '@/styles/main.scss';
import '@/styles/mixins.scss';

createApp(App).use(router).mount('#app')
